import { errorCode } from '@/assets/config/errorCode';
import { elMessage } from '@/utils/index';
import instance from './index'
import epgInstace from './epgInstance'
import { testBalanceInstance, dynamicInstance, useParamsUrlInstance } from './traceDebugInstance'
import liveInstance from './liveInstance'

let isTimeOut = null
const keepOnLineState = () => {
  clearInterval(isTimeOut)
  isTimeOut = setInterval(() => {
    sessionStorage.setItem('lastClickTime', new Date().getTime() as any)
  }, 1000)
}

// 需要在页面自定义提示，
let formatCode = ['V5002']

export function axiosInstance(config: any) {
  return new Promise((resolve, reject) => {
    keepOnLineState()
    instance(config).then(response => {
      clearInterval(isTimeOut)
      if (response.data.code != '0' && response.config.responseType !== 'blob') {
        // 导入导出响应blob类型数据，不需要走这里的判断
        // elMessage('error', errorCode[response.data.code] || response.data.msg)
        // elMessage('error', response.data.msg)
        if (!formatCode.includes(response.data.code)) {
          elMessage('error', errorCode[response.data.code] || response.data.msg)
        }
      }
      resolve(response.data);
    }).catch(err => {
      clearInterval(isTimeOut)
      // elMessage('error', errorCode[err.code] || err.message)
      reject(err);
    })
  })
}


/**
 * 封装通用的可配置参数的请求方法，返回 response
 * @param config：axios 配置项
 */
export function axiosInstanceAll(config) {
  keepOnLineState()
  return instance(config).then(response => {
    clearInterval(isTimeOut)
    return response;
  }).catch(err => {
    clearInterval(isTimeOut)
    // let elMessageDoms = document.getElementsByClassName('el-message');
    // if (!elMessageDoms.length) {
    //   elMessage('error', errorCode[err.code] || err.message)
    // } else {
    //   for (let i = 0; i < elMessageDoms.length; i++) {
    //     if (err.message != elMessageDoms[i].getElementsByClassName('el-message__content')[0].innerHTML) {
    //       elMessage('error', errorCode[err.code] || err.message)
    //     }
    //   }
    // }
    // elMessage('error', errorCode[err.code] || err.message)
    return Promise.reject(err);
  })
}


/**
 * 文件下载时从头部获取文件名
 * @param disposition      返回头部 content-disposition' 内容
 */
export const getFileNameFromDisposition = (disposition) => {
  if (!disposition) {
    return ''
  }
  let fileName = disposition.split(";")[1].split("filename=")[1]

  let fileNameUnicode = disposition.split("filename*=")[1]
  if (fileNameUnicode) {
    //当存在 filename* 时，取filename* 并进行解码（为了解决中文乱码问题）
    fileName = decodeURIComponent(fileNameUnicode.split("''")[1])
  } else {
    fileName = decodeURIComponent(fileName)
  }
  return fileName
}

/**
 * 封装通用获取文件 blob 流方法，包括处理异常
 * @param {*} config 
 * @returns 
 */
export function axiosFileBlob(config) {
  keepOnLineState()
  config.responseType = 'blob';            // 由于是专用于文件下载，故强制设置该参数
  return axiosInstanceAll(config).then(response => {
    clearInterval(isTimeOut)
    let headers = response ? response.headers : {}
    // headers.hasOwnProperty('business-code')
    // 因为后端的网关加上business-code这个字段会导致后端报错，所以后端要求通过判断content-type类型来判断接口是否出错
    if (headers['content-type'] == "application/json") {
      // 有这个头部，代表文件下载错误
      let blob = (response && response.data) ? response.data : null
      let reader: any = new FileReader();
      reader.readAsText(blob, 'utf-8')
      reader.onload = e => {
        let result = reader.result ? JSON.parse(reader.result) : {}
        elMessage('error', errorCode[result.code])
      }
      return Promise.reject(response)
    } else {
      // 经错处理后的数据
      let processData = {
        contentType: response.data.type,            // 文件类型
        fileName: getFileNameFromDisposition(response.headers['content-disposition'])       // 文件名
      }
      const c_response: any = response
      c_response.processData = processData;
      // 将处理后的数据返回出去，去外部下载
      return c_response
    }
  }, err => {
    clearInterval(isTimeOut)
    return Promise.reject(err);
  }).catch(err => {
    clearInterval(isTimeOut)
    Promise.reject(err);
  })
}

// epg检查
export function epgCheckInstance(config: any) {
  return new Promise((resolve, reject) => {
    keepOnLineState()
    epgInstace(config).then(response => {
      clearInterval(isTimeOut)
      // if(response.data.code != '0' && response.config.responseType !== 'blob'){
      //   // 导入导出响应blob类型数据，不需要走这里的判断
      //   elMessage('error', response.data.msg)
      // }
      resolve(response.data);
    }).catch(err => {
      clearInterval(isTimeOut)
      reject(err);
    })
  })
}

// 跟踪调试模块用的axios实例
/**baseUrl是:http://192.168.30.251:8600 */
export function testBalanceInstances(config: any) {
  return new Promise((resolve, reject) => {
    keepOnLineState()
    testBalanceInstance(config).then(response => {
      clearInterval(isTimeOut)
      resolve(response.data);
    }).catch(err => {
      clearInterval(isTimeOut)
      reject(err);
    })
  })
}
export function dynamicInstances(config: any) {
  return new Promise((resolve, reject) => {
    keepOnLineState()
    dynamicInstance(config).then(response => {
      clearInterval(isTimeOut)
      resolve(response.data);
    }).catch(err => {
      clearInterval(isTimeOut)
      reject(err);
    })
  })
}
export function useParamsUrlInstances(config: any) {
  return new Promise((resolve, reject) => {
    keepOnLineState()
    useParamsUrlInstance(config).then(response => {
      clearInterval(isTimeOut)
      resolve(response.data);
    }).catch(err => {
      clearInterval(isTimeOut)
      reject(err);
    })
  })
}

/**直播模块用的instance */
export function live_instance(config: any) {
  return new Promise((resolve, reject) => {
    keepOnLineState()
    liveInstance(config).then(response => {
      clearInterval(isTimeOut)
      if (response.data.code != '0' && response.config.responseType !== 'blob') {
        // 导入导出响应blob类型数据，不需要走这里的判断
        // elMessage('error', errorCode[response.data.code] || response.data.msg)
        // elMessage('error', response.data.msg)
        if (!formatCode.includes(response.data.code)) {
          elMessage('error', errorCode[response.data.code] || response.data.msg || response.data.message)
        }
      }
      resolve(response.data);
    }).catch(err => {
      clearInterval(isTimeOut)
      // elMessage('error', errorCode[err.code] || err.message)
      reject(err);
    })
  })
}

/**
 * 封装通用获取文件 blob 流方法，包括处理异常
 * @param {*} config 
 * @returns 
 */
export function axiosFileBlob_live(config) {
  keepOnLineState()
  config.responseType = 'blob';            // 由于是专用于文件下载，故强制设置该参数
  return liveInstance(config).then(response => {
    clearInterval(isTimeOut)
    let headers = response ? response.headers : {}
    // headers.hasOwnProperty('business-code')
    // 因为后端的网关加上business-code这个字段会导致后端报错，所以后端要求通过判断content-type类型来判断接口是否出错
    if (headers['content-type'] == "application/json") {
      // 有这个头部，代表文件下载错误
      let blob = (response && response.data) ? response.data : null
      let reader: any = new FileReader();
      reader.readAsText(blob, 'utf-8')
      reader.onload = e => {
        let result = reader.result ? JSON.parse(reader.result) : {}
        elMessage('error', errorCode[result.code])
      }
      return Promise.reject(response)
    } else {
      // 经错处理后的数据
      let processData = {
        contentType: response.data.type,            // 文件类型
        fileName: getFileNameFromDisposition(response.headers['content-disposition'])       // 文件名
      }
      const c_response: any = response
      c_response.processData = processData;
      // 将处理后的数据返回出去，去外部下载
      return c_response
    }
  }, err => {
    clearInterval(isTimeOut)
    return Promise.reject(err);
  }).catch(err => {
    clearInterval(isTimeOut)
    Promise.reject(err);
  })
}